module.exports = __webpack_public_path__ + "fonts/Barlow-Light.032fe48c.ttf";